
import React from "react";
import { useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import { getLeadsAction } from "../../../../store/actions/LeadAction"
import { getAssignedHistoryAction } from "../../../../store/actions/LeadHistoryAction.js";
import Loader from "../../Common/Loader.jsx"
import { formatName } from "../../../../utils/formatName.js"

const AssignedHistory = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    // Redux state - properly accessing leadState
    // const leadState = useSelector((state) => state.leadState || {})
    //const { leads: reduxLeads = [], telecallers = [], loading = false, error = null, num_rows = 0 } = leadState


    const { assignedHistory = [], num_rows = 0, loading = false, error = null } =
        useSelector((state) => state.leadHistory || {});


    const [isLoading, setIsLoading] = useState(false)
    const userDetails = JSON.parse(localStorage.getItem("userDetails"))
    // Local state
    // const [leads, setLeads] = useState([])
    const [searchQueries, setSearchQueries] = useState({
        lead_id: "",
        lead_name: "",
        lead_email: "",
        lead_dob: "",
        // lead_phone: "",
        disease_name: "",
        telecaller_name: "",
    })

    // Sorting states
    const [sortField, setSortField] = useState("lead_id")
    const [sortOrder, setSortOrder] = useState("asc")
    // Pagination states - DYNAMIC
    const [currentPage, setCurrentPage] = useState(0)
    const rowsPerPage = 10
    // Track active search for server-side filtering
    const [activeSearchField, setActiveSearchField] = useState("")
    const [activeSearchKeyword, setActiveSearchKeyword] = useState("")
    // Status filtering
    const [statusFilter, setStatusFilter] = useState("All")
    const [selectAll, setSelectAll] = useState(false)
    const [searchTelecaller, setSearchTelecaller] = useState("")

    // Fetch leads on component mount
    // useEffect(() => {
    //     const fetchLeads = async () => {
    //         setIsLoading(true)
    //         try {
    //             await fetchLeadsFromServer()
    //         } catch (err) {
    //             console.error("Failed to fetch leads:", err)
    //         } finally {
    //             setIsLoading(false)
    //         }
    //     }
    //     fetchLeads()
    // }, [dispatch])

    const fetchAssignedHistory = async (
        search_by = "",
        search_keyword = "",
        pagination = true,
        pageid = 0,
        sort_by = sortField,
        sort_order = sortOrder,
        status = statusFilter
    ) => {
        await dispatch(
            getAssignedHistoryAction(
                pagination,
                pageid,
                search_by,
                search_keyword,
                sort_by,
                sort_order,
                status
            )
        );
    };

    useEffect(() => {
        fetchAssignedHistory();
    }, []);

    // useEffect(() => {
    //     dispatch(getAssignedHistoryAction());
    // }, [dispatch]);


    // Update local state when redux state changes
    // useEffect(() => {
    //     if (assignedHistory && assignedHistory.length > 0) {
    //         const formatted = assignedHistory.map((item) => ({
    //             lead_id: item.lead_id,
    //             lead_name: item.full_name || "-",
    //             telecaller_name: item.telecaller_name || "-",
    //             lead_phone: item.phone_no || "-",
    //             lead_priority: item.lead_type || "-",
    //             diseases: Array.isArray(item.diseases) ? item.diseases : [],
    //             questionnaire_filled: item.questionnaire_filled || "No",
    //             is_converted: item.is_converted || "Not Converted",
    //         }));

    //         setLeads(formatted);
    //     } else {
    //         setLeads([]);
    //     }
    // }, [assignedHistory]);


    // useEffect(() => {
    //     if (reduxLeads && reduxLeads.length > 0) {
    //         const formattedLeads = reduxLeads.map((lead) => {
    //             const safeDiseases = Array.isArray(lead.diseases) ? lead.diseases : []
    //             const marriageData = lead.marriageInfo || null;
    //             return {
    //                 lead_id: lead.lead_id,
    //                 lead_name: lead.lead_name || "",
    //                 lead_email: lead.lead_email || "-",
    //                 lead_city: lead.lead_city || "-",
    //                 lead_phone: lead.lead_phone || "",
    //                 lead_priority: lead.lead_priority || "-",
    //                 diseases: safeDiseases,
    //                 lead_status: lead.lead_status || "",
    //                 is_converted: lead.is_converted || "Not Converted",
    //                 platform: lead.platform || "",
    //                 created_time: lead.created_time || "",
    //                 ad_name: lead.ad_name || "",
    //                 questionnaire_filled: lead.questionnaire_filled || "No",
    //                 patient_id: lead.patient_id || null,
    //                 selected: false,
    //                 marriageInfo: marriageData,
    //             }
    //         })


    //         const filteredLeads =
    //             statusFilter === "All"
    //                 ? formattedLeads
    //                 : formattedLeads.filter((lead) => lead.is_converted === statusFilter)

    //         setLeads(filteredLeads)
    //     } else {
    //         setLeads([])
    //     }
    // }, [reduxLeads, statusFilter])



    // DYNAMIC SERVER-SIDE FETCH FUNCTION
    // const fetchLeadsFromServer = async (
    //     search_by = activeSearchField,
    //     search_keyword = activeSearchKeyword,
    //     sort_by = sortField,
    //     sort_order = sortOrder,
    //     pagination = true,
    //     pageid = currentPage,
    //     status = statusFilter
    // ) => {
    //     try {
    //         // setIsLoading(true)
    //         await dispatch(
    //             getLeadsAction(
    //                 pagination,
    //                 pageid,
    //                 status,
    //                 search_by,
    //                 search_keyword,
    //                 sort_by,
    //                 sort_order
    //             )
    //         )
    //     } catch (err) {
    //         console.error("Failed to fetch Leads:", err)
    //     } finally {
    //         // setIsLoading(false)
    //     }
    // }

    // DYNAMIC PAGE CHANGE HANDLER
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchAssignedHistory(
            activeSearchField,
            activeSearchKeyword,
            true,
            page,
            sortField,
            sortOrder,
            statusFilter
        );
    };


    // Handle search with server-side filtering
    const handleSearch = (e, field) => {
        const keyword = e.target.value;

        const clearedQueries = {
            lead_name: "",
            telecaller_name: "",
            // phone_no: "",
            lead_type: "",
            disease_name: "",
        };

        setCurrentPage(0);

        if (keyword.trim() === "") {
            // 🔥 FULL RESET
            setSearchQueries(clearedQueries);
            setActiveSearchField("");
            setActiveSearchKeyword("");

            fetchAssignedHistory("", "", true, 0, sortField, sortOrder);
        } else {
            const updatedQueries = { ...clearedQueries, [field]: keyword };
            setSearchQueries(updatedQueries);

            setActiveSearchField(field);
            setActiveSearchKeyword(keyword);

            fetchAssignedHistory(field, keyword, true, 0, sortField, sortOrder);
        }
    };



    // Handle sort with server-side sorting
    const handleSort = (field) => {
        const order =
            sortField === field && sortOrder === "asc" ? "desc" : "asc";

        setSortField(field);
        setSortOrder(order);
        setCurrentPage(0);

        fetchAssignedHistory(
            activeSearchField,
            activeSearchKeyword,
            true,
            0,
            field,
            order,
            statusFilter
        );
    };

    // <th onClick={() => handleSort("phone_no")} style={{ cursor: "pointer" }}>
    //     Telecaller Phone  {sortField === "phone_no" && (sortOrder === "asc" ? "↑" : "↓")}
    //     <input
    //         className="form-control form-control-sm mt-1"
    //         value={searchQueries.phone_no}
    //         onChange={(e) => handleSearch(e, "phone_no")}
    //         placeholder="Search Phone"
    //         onClick={(e) => e.stopPropagation()}
    //     />
    // </th>
    // Handle status filter change
    const handleStatusFilterChange = (newStatus) => {
        setStatusFilter(newStatus)
        setCurrentPage(0)
        fetchLeadsFromServer(
            activeSearchField,
            activeSearchKeyword,
            sortField,
            sortOrder,
            true,
            0,
            newStatus
        )
    }

    // DYNAMIC PAGINATION CALCULATION
    const totalPages = Math.ceil(num_rows / rowsPerPage)

    // Handle view details
    const handleViewDetails = (lead) => {
        navigate(`/app-lead-details/${lead.lead_id}`, {
            state: {
                fromLeadsTable: true,
                questionnaireFilledStatus: lead.questionnaire_filled,
                isConverted: lead.is_converted,
                patient_id: lead.patient_id,
            },
        })
    }


    // Filter telecallers
    // const filteredTelecallers = Array.isArray(telecallers)
    //     ? telecallers.filter((caller) =>
    //         caller.name?.toLowerCase().includes(searchTelecaller.toLowerCase())
    //     )
    //     : []
    // Check if any leads are selected
    // const hasSelectedLeads = leads.some((lead) => lead.selected)

    if (isLoading) {
        return <Loader />
    }

    return (
        <>

            {/* Table & Filters */}
            {/* <th onClick={() => handleSort("phone_no")} style={{ cursor: "pointer" }}>
                Telecaller Phone  {sortField === "phone_no" && (sortOrder === "asc" ? "↑" : "↓")}
                <input
                    className="form-control form-control-sm mt-1"
                    value={searchQueries.phone_no}
                    onChange={(e) => handleSearch(e, "phone_no")}
                    placeholder="Search Phone"
                    onClick={(e) => e.stopPropagation()}
                />
            </th> */}
           <div className="d-flex justify-content-end align-items-center mb-3">
    <div className="d-flex align-items-center gap-2">
        <label className="fw-semibold mb-0">Status:</label>

        <Select
            className="react-select-container"
            classNamePrefix="react-select"
            value={{
                value: statusFilter,
                label: statusFilter,
            }}
            onChange={(selectedOption) => {
                const newStatus = selectedOption.value;   // ✅ define it
            
                setStatusFilter(newStatus);
                setCurrentPage(0);
            
                fetchAssignedHistory(
                    activeSearchField,
                    activeSearchKeyword,
                    true,
                    0,
                    sortField,
                    sortOrder,
                    newStatus
                );
            }}
            options={[
                { value: "All", label: "All" },
                { value: "Converted", label: "Converted" },
                { value: "Not Converted", label: "Not Converted" },
            ]}
            isSearchable={false}
            styles={{
                container: (base) => ({
                    ...base,
                    width: 180,
                }),
            }}
        />
    </div>
</div>


            <div className="row">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body">
                            {error && <div className="text-danger mb-2">{error}</div>}
                            {loading ? (
                                <div className="text-center my-5">
                                    <Loader size="lg" />
                                </div>
                            ) : (
                                <>
                                    {/* Lead Table */}
                                    <div className="table-responsive">
                                        <table className="table table-striped mb-4">
                                            <thead className="table-light">
                                                <tr>
                                                    <th onClick={() => handleSort("full_name")} style={{ cursor: "pointer" }}>
                                                        Patient Name {sortField === "full_name" && (sortOrder === "asc" ? "↑" : "↓")}
                                                        <input
                                                            className="form-control form-control-sm mt-1"
                                                            value={searchQueries.full_name}
                                                            onChange={(e) => handleSearch(e, "full_name")}
                                                            placeholder="Search Name"
                                                            onClick={(e) => e.stopPropagation()}
                                                        />
                                                    </th>

                                                    <th onClick={() => handleSort("telecaller_name")} style={{ cursor: "pointer" }}>
                                                        Assign to{sortField === "telecaller_name" && (sortOrder === "asc" ? "↑" : "↓")}
                                                        <input
                                                            className="form-control form-control-sm mt-1"
                                                            value={searchQueries.telecaller_name}
                                                            onChange={(e) => handleSearch(e, "telecaller_name")}
                                                            placeholder="Search Telecaller"
                                                            onClick={(e) => e.stopPropagation()} // prevent sort on click
                                                        />
                                                    </th>
                                                    {/* <th onClick={() => handleSort("phone_no")} style={{ cursor: "pointer" }}>
                                                        Telecaller Phone  {sortField === "phone_no" && (sortOrder === "asc" ? "↑" : "↓")}
                                                        <input
                                                            className="form-control form-control-sm mt-1"
                                                            value={searchQueries.phone_no}
                                                            onChange={(e) => handleSearch(e, "phone_no")}
                                                            placeholder="Search Phone"
                                                            onClick={(e) => e.stopPropagation()}
                                                        />
                                                    </th> */}

                                                    <th onClick={() => handleSort("lead_type")} style={{ cursor: "pointer" }}>
                                                        Lead Type{sortField === "lead_type" && (sortOrder === "asc" ? "↑" : "↓")}
                                                        <input
                                                            className="form-control form-control-sm mt-1"
                                                            value={searchQueries.lead_type}
                                                            onChange={(e) => handleSearch(e, "lead_type")}
                                                            placeholder="Search Priority"
                                                            onClick={(e) => e.stopPropagation()}
                                                        />
                                                    </th>

                                                    <th onClick={() => handleSort("disease_name")} style={{ cursor: "pointer" }}>
                                                        Diseases {sortField === "disease_name" && (sortOrder === "asc" ? "↑" : "↓")}
                                                        <input
                                                            className="form-control form-control-sm mt-1"
                                                            value={searchQueries.disease_name}
                                                            onChange={(e) => handleSearch(e, "disease_name")}
                                                            placeholder="Search Diseases"
                                                            onClick={(e) => e.stopPropagation()}
                                                        />
                                                    </th>
                                                    <th>Status</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(() => {
                                                    const filteredData = assignedHistory.filter((item) => {
                                                        if (statusFilter === "All") return true;
                                                        return item.is_converted === statusFilter;
                                                    });

                                                    if (filteredData.length === 0) {
                                                        return (
                                                            <tr>
                                                                <td colSpan="6" className="text-center py-4">
                                                                    No leads found
                                                                </td>
                                                            </tr>
                                                        );
                                                    }

                                                    return filteredData.map((item) => (
                                                        <tr key={item.lead_id}>
                                                            <td>{formatName(item.full_name)}</td>
                                                            <td>{item.telecaller_name || "-"}</td>
                                                            <td>{item.lead_type}</td>


                                                            {/* Diseases */}
                                                            <td>
                                                                {item.diseases?.length > 0
                                                                    ? item.diseases.map((d) => d.disease_name).join(", ")
                                                                    : "-"}
                                                            </td>

                                                            {/* Converted Badge */}
                                                            <td>
                                                                <span
                                                                    className={`badge ${item.is_converted === "Converted"
                                                                        ? "bg-success"
                                                                        : "bg-danger"
                                                                        }`}
                                                                >
                                                                    {item.is_converted}
                                                                </span>
                                                            </td>

                                                            <td className="text-center">
                                                                <Link
                                                                    to="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        handleViewDetails(item);
                                                                    }}
                                                                    className="text-info"
                                                                >
                                                                    <i className="fa fa-eye fs-5" />
                                                                </Link>
                                                            </td>
                                                        </tr>
                                                    ));
                                                })()}
                                            </tbody>

                                        </table>
                                    </div>

                                    {/* DYNAMIC PAGINATION */}
                                    {num_rows > 0 && (
                                        <div
                                            className="pagination-wrapper"
                                            style={{
                                                display: "flex",
                                                gap: "6px",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                marginTop: "20px",
                                                flexWrap: "wrap",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <div>
                                                Showing {assignedHistory?.length === 0 ? 0 : currentPage * rowsPerPage + 1} to{" "}
                                                {Math.min((currentPage + 1) * rowsPerPage, num_rows)} of {num_rows} entries
                                            </div>
                                            <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", justifyContent: "center" }}>
                                                <button
                                                    onClick={() => handlePageChange(Math.max(currentPage - 1, 0))}
                                                    disabled={currentPage === 0}
                                                    style={{
                                                        padding: "6px 12px",
                                                        border: "1px solid #ddd",
                                                        borderRadius: "4px",
                                                        backgroundColor: "#fff",
                                                        color: "#000",
                                                        cursor: currentPage === 0 ? "not-allowed" : "pointer",
                                                        opacity: currentPage === 0 ? 0.5 : 1,
                                                    }}
                                                >
                                                    &lt;
                                                </button>
                                                {(() => {
                                                    const pages = []
                                                    const maxPagesToShow = 5
                                                    const startPage = Math.max(
                                                        0,
                                                        Math.min(currentPage - 2, totalPages - maxPagesToShow)
                                                    )
                                                    const endPage = Math.min(startPage + maxPagesToShow, totalPages)

                                                    if (startPage > 0) {
                                                        pages.push(
                                                            <button
                                                                key={0}
                                                                onClick={() => handlePageChange(0)}
                                                                style={{
                                                                    padding: "6px 12px",
                                                                    border: "1px solid #ddd",
                                                                    borderRadius: "4px",
                                                                    backgroundColor: "#fff",
                                                                    color: "#000",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                1
                                                            </button>
                                                        )
                                                        if (startPage > 1) {
                                                            pages.push(
                                                                <span key="dots1" style={{ padding: "6px 12px", userSelect: "none" }}>
                                                                    ...
                                                                </span>
                                                            )
                                                        }
                                                    }

                                                    for (let i = startPage; i < endPage; i++) {
                                                        const isActive = currentPage === i
                                                        pages.push(
                                                            <button
                                                                key={i}
                                                                onClick={() => handlePageChange(i)}
                                                                style={{
                                                                    padding: "6px 12px",
                                                                    border: "1px solid #ddd",
                                                                    borderRadius: "4px",
                                                                    backgroundColor: isActive ? "#007bff" : "#fff",
                                                                    color: isActive ? "#fff" : "#000",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                {i + 1}
                                                            </button>
                                                        )
                                                    }

                                                    if (endPage < totalPages) {
                                                        if (endPage < totalPages - 1) {
                                                            pages.push(
                                                                <span key="dots2" style={{ padding: "6px 12px", userSelect: "none" }}>
                                                                    ...
                                                                </span>
                                                            )
                                                        }
                                                        pages.push(
                                                            <button
                                                                key={totalPages - 1}
                                                                onClick={() => handlePageChange(totalPages - 1)}
                                                                style={{
                                                                    padding: "6px 12px",
                                                                    border: "1px solid #ddd",
                                                                    borderRadius: "4px",
                                                                    backgroundColor: "#fff",
                                                                    color: "#000",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                {totalPages}
                                                            </button>
                                                        )
                                                    }
                                                    return pages
                                                })()}
                                                <button
                                                    onClick={() => handlePageChange(Math.min(currentPage + 1, totalPages - 1))}
                                                    disabled={currentPage === totalPages - 1}
                                                    style={{
                                                        padding: "6px 12px",
                                                        border: "1px solid #ddd",
                                                        borderRadius: "4px",
                                                        backgroundColor: "#fff",
                                                        color: "#000",
                                                        cursor: currentPage === totalPages - 1 ? "not-allowed" : "pointer",
                                                        opacity: currentPage === totalPages - 1 ? 0.5 : 1,
                                                    }}
                                                >
                                                    &gt;
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AssignedHistory;

